clickableBlock = document.querySelectorAll('.clickable');

if (clickableBlock) {
    clickableBlock.forEach(function (el) {
        el.addEventListener('click', function (e) {
            var url = this.getElementsByClassName('url')[0].href;
            var target = this.getElementsByClassName('url')[0].target;

            window.open(url, target);
        });
    });
}

clickableItemsGrid = document.querySelector('#mse2_results');

if (clickableItemsGrid) {
    let MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    let observer = new MutationObserver(resultsItemsChanged);
    observer.observe(clickableItemsGrid, {
        childList: true
    });
}

function resultsItemsChanged() {
    clickableBlock = document.querySelectorAll('.clickable');

    if (clickableBlock) {
        clickableBlock.forEach(function (el) {
            el.addEventListener('click', function (e) {
                var url = this.getElementsByClassName('url')[0].href;
                var target = this.getElementsByClassName('url')[0].target;

                window.open(url, target);
            });
        });
    }
}

copyUrl = document.querySelectorAll('.copyurl');

if (copyUrl) {
    copyUrl.forEach(function (el) {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            copyText(this);
        });
    });
}

function copyText(element) {
    var textToCopy = element.href;
    var myTemporaryInputElement = document.createElement('input');
    myTemporaryInputElement.type = 'text';
    myTemporaryInputElement.value = textToCopy;
    document.body.appendChild(myTemporaryInputElement);
    myTemporaryInputElement.select();
    document.execCommand('Copy');
    document.body.removeChild(myTemporaryInputElement);
}

